import React from 'react';
import PropTypes from 'prop-types';
import { formatRoute } from 'react-router-named-routes';
import { Card, CardContent, CardMedia, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import imgPlaceholder from '../../assets/images/shopping_list_card.png';
import { MY_DAY_SHOPPING_LIST_ROUTE } from '../../services/routes';
import { useListProductsBoardQuery } from '../../app/smorgAppSyncGraphQLApi';
import { useGetShoppingListByIDAndParentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import MyDayPlaceholderCard from './my_day_placeholder_card';

const MyDayShoppingListCard = ({ shoppingListID }) => {
  const navigate = useNavigate();

  const { data: productsBoard } = useListProductsBoardQuery();

  const { data: shoppingList, isSuccess: isShoppingListSuccess } =
    useGetShoppingListByIDAndParentQuery(
      { id: shoppingListID, parentID: productsBoard?.id },
      {
        skip: !shoppingListID || !productsBoard?.id,
      },
    );

  const title = shoppingList?.title;

  const theme = useTheme();

  const hasLoadedSuccessfully = isShoppingListSuccess;

  if (hasLoadedSuccessfully && !shoppingList) {
    return null;
  }

  return !hasLoadedSuccessfully ? (
    <MyDayPlaceholderCard />
  ) : (
    <Card
      className="my-day-compact-content-card"
      style={{ backgroundColor: theme.palette.primary.cardBackground }}
      onClick={() => {
        navigate(
          formatRoute(MY_DAY_SHOPPING_LIST_ROUTE, {
            shoppingListID,
          }),
        );
      }}>
      <div style={{ height: '144px', display: 'flex' }}>
        <CardMedia
          sx={{ height: '123px', width: '123px', margin: 'auto' }}
          image={imgPlaceholder}
        />
      </div>
      <CardContent
        sx={{
          flex: '1 0 auto',
          margin: '8px',
          padding: '0 !important',
          fontSize: '14px',
          whiteSpace: 'break-spaces',
        }}
        style={{
          color: 'white',
          lineClamp: 3,
          WebkitLineClamp: 3,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
        }}>
        {title}
      </CardContent>
    </Card>
  );
};

MyDayShoppingListCard.propTypes = {
  shoppingListID: PropTypes.string.isRequired,
};

export default MyDayShoppingListCard;
